export default {
    bill: {
        name: 'Fatura | Faturas',
        attributes: {
            discount: 'Desconto',
            dueAt: 'Data de Vencimento',
            interest: 'Juros',
            totalValue: 'Valor Total',
            value: 'Valor',
        },
        getters: {
            status: {
                paid: 'Pago',
                pending: 'Pendente',
            },
        },
        actions: {
            accessPaymentPage: 'Acessar Página de Pagamento',
            accessNF: 'Acessar NF',
        },
    },

    period: {
        name: 'Período | Períodos',
        attributes: {
            customerName: 'Cliente',
            dueAt: 'Vencimento',
            endAt: 'Fim',
            planName: 'Plano',
            situation: 'Situação',
            startAt: 'Início',
            totalValue: 'Valor Total',
            value: 'Valor',
        },
    },

    'plan-proposal': {
        name: 'Proposta de Plano | Propostas de Planos',
        attributes: {
            customer: 'Cliente',
            plan: 'Plano',
            totalPrice: 'Valor Total',
            finalPrice: 'Valor Final',
            requestedAt: 'Data de Requisição',
            approvedAt: 'Data de Aprovação',
            rejectedAt: 'Data de Rejeição',
            expireAt: 'Data de Expiração',
            consultantName: 'Consultor',
            consultantId: 'ID do Consultor',
            corporate: 'Corporativo',
            proposalSentAt: 'Data de Envio da Proposta',
            approvedProposal: 'Proposta Aprovada',
            finalizedAt: 'Data de Finalização',
            status: 'Situação',
            url: 'URL',
            errorContent: 'Conteúdo do Erro',
            deletedAt: 'Data de Exclusão',
        },
    },
}
